import PropTypes from "prop-types";
import React from "react";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

const Userimage = ({src}) => {
    return(
        <div className="w-10 h-10 rounded-full overflow-hidden flex justify-center items-center">
            {src ?
                <img src={src} alt="user-profile" className="h-full w-full"/>
                 :   
                <AccountCircleIcon fontSize="medium" color="textSecondary"/>
            }
        </div>
    )
}

Userimage.propTypes = {
    src: PropTypes.string.isRequired,
}

Userimage.defaultProps = {
    src: PropTypes.string.isRequired,
}

export default Userimage